module.exports = __webpack_public_path__ + "img/iconmonstr-smartphone-4.afc44011.svg";